module.exports = __webpack_public_path__ + "68360c178869b9823dc405815a79fb33.png";